import { SET_TIMERS, SET_TIMER_LIST, SET_SELECTED_TIMER } from './actions';
import { merge } from '@its/util';

export default (state = [], action) => {
  switch (action.type) {
    case SET_TIMERS:
      return merge(state, { items: action.payload });
    case SET_TIMER_LIST:
      return merge(state, { list: action.payload });
    case SET_SELECTED_TIMER:
      return merge(state, { detail: action.payload });
    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/timer/reducer.js
 **/